import type { _Map, ListDatasetsResponse, Site } from '../generated'

interface MockSites {
  [siteName: string]: Site
}

interface MockMaps {
  [siteName: string]: {
    maps: _Map[]
  }
}

interface MockDatasets {
  [siteName: string]: {
    [mapName: string]: ListDatasetsResponse
  }
}

export const mockSites: MockSites = {
  council: {
    name: 'API - Default Demo Council',
    favicon_url: 'https://config.pozi.com/public/files/MNG-fav.png',
    site_logo_url: 'https://config.pozi.com/public/files/MNG-Approved_resized.png',
    print_logo_url: 'https://config.pozi.com/public/files/MNG-Approved_resized.png',
  },
  frankston: {
    name: 'API - Frankston City Council',
    favicon_url: 'https://s3.ap-southeast-2.amazonaws.com/s3.pozi.com/img/logos/favicons/frankston_fav.png',
    site_logo_url: 'https://s3.ap-southeast-2.amazonaws.com/s3.pozi.com/img/logos/mapLogos/frankston_biglogo.png',
    print_logo_url: '',
  },
  junee: {
    name: 'API - Junee Shire Council',
    favicon_url: 'https://config.pozi.com/public/files/junee_logo.png',
    site_logo_url: 'https://config.pozi.com/public/files/junee_logo.png',
    print_logo_url: 'https://config.pozi.com/public/files/junee_logo.png',
  },
  gleneira: {
    name: 'API - Glen Eira City Council',
    favicon_url: 'https://s3.ap-southeast-2.amazonaws.com/s3.pozi.com/img/logos/favicons/gleneira_logo.png',
    site_logo_url: 'https://s3.ap-southeast-2.amazonaws.com/s3.pozi.com/img/logos/mapLogos/gleneira_biglogo.png',
    print_logo_url: '',
  }
}

export const mockMaps: MockMaps = {
  council: {
    maps: [
      {
        name: 'public',
        title: 'API - Demo Council Community Map',
        description: '<p>This is a <b>DEMO PUBLIC</b> map served using the new Pozi API.</p>',
        disclaimer: 'Disclaimer: This is a DEMO PUBLIC map, it is not a real map.',
        bounding_box: [115.823, -31.912, 115.886, -31.95]
      },
      {
        name: 'enterprise',
        title: 'API - Demo Council Enterprise Map',
        description: '<p>This is a <b>DEMO ENTERPRISE</b> map served using the new Pozi API.</p>',
        disclaimer: 'Disclaimer: This is a DEMO ENTERPRISE map, it is not a real map.',
        bounding_box: [115.823, -31.912, 115.886, -31.95]
      },
      {
        name: 'planning',
        title: 'API - Demo Council Planning Map',
        description: '<p>This is a <b>DEMO PLANNING</b> map served using the new Pozi API.</p>',
        disclaimer: 'Disclaimer: This is a DEMO PLANNING map, it is not a real map.',
        bounding_box: [115.823, -31.912, 115.886, -31.95]
      }
    ]
  },
  frankston: {
    maps: [
      {
        name: 'public',
        title: 'API - Frankston Community Map',
        description: '<p>This is the <b>FRANKSTON PUBLIC</b> map served using the new Pozi API.</p>',
        disclaimer: 'Disclaimer: This is a DEMO FRANKSTON PUBLIC map, it is not a real map.',
        bounding_box: [145.1, -38.07, 145.25, -38.2]
      }
    ]
  },
  junee: {
    maps: [
      {
        name: 'public',
        title: 'API - Junee Community Map',
        description: '<p>This is the <b>JUNEE PUBLIC</b> map served using the new Pozi API.</p>',
        disclaimer: 'Disclaimer: This is a DEMO JUNEE PUBLIC map, it is not a real map.',
        bounding_box: [147.3, -35.1, 148, -34.5]
      }
    ]
  },
  gleneira: {
    maps: []
  }
}

export const mockDatasets: MockDatasets = {
  council: {
    public: {
      mapdatasets: [
        {
          group_name: 'Core',
          datasets: [
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92qi8',
              title: 'General',
              type: 1,
              url: 'https://server1.pozi.com/Pozi/qgisserver?MAP=F:/Projects/MNGdemo/GeneralEnquiry.qgs',
              show_legend: true
            },
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92fb7',
              title: 'LGA Boundary',
              type: 1,
              url: 'https://server1.pozi.com/Pozi/qgisserver?MAP=F:/Projects/Test/API/Council.qgs',
              show_legend: true
            }
          ]
        },
        {
          group_name: 'Imagery',
          datasets: [
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92fa8',
              title: 'ArcGIS World Imagery',
              type: 4,
              url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
              show_legend: true
            }
          ]
        },
        {
          group_name: 'Basemap',
          datasets: [
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92fa9',
              title: 'OpenStreetMap',
              type: 4,
              url: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png',
              show_legend: true
            }
          ]
        }
      ]
    },
    enterprise: {
      mapdatasets: [
        {
          group_name: 'Core',
          datasets: [
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92ga7',
              title: 'Properties',
              type: 1,
              url: 'https://server1.pozi.com/Pozi/qgisserver?MAP=F:/Projects/MNGdemo/Core.qgs',
              show_legend: true
            },
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92gb7',
              title: 'LGA Boundary',
              type: 1,
              url: 'https://server1.pozi.com/Pozi/qgisserver?MAP=F:/Projects/Test/API/Council.qgs',
              show_legend: true
            }
          ]
        },
        {
          group_name: 'Imagery',
          datasets: [
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92ga8',
              title: 'ArcGIS World Imagery',
              type: 4,
              url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
              show_legend: true
            }
          ]
        },
        {
          group_name: 'Basemap',
          datasets: [
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92ga9',
              title: 'OpenStreetMap',
              type: 4,
              url: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png',
              show_legend: true
            },
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92kb9',
              title: 'HERE Map',
              type: 4,
              url: 'https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?style=explore.day&apiKey=uvyumsPYCINCZ_GY4GJqXeDbsj4DykbAic1qJNA4eHs',
              show_legend: true
            }
          ]
        }
      ]
    },
    planning: {
      mapdatasets: [
        {
          group_name: 'Property',
          datasets: [
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92ha7',
              title: 'Properties',
              type: 1,
              url: 'https://server1.pozi.com/Pozi/qgisserver?MAP=F:/Projects/MNGdemo/Core.qgs',
              show_legend: true
            },
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92hb7',
              title: 'LGA Boundary',
              type: 1,
              url: 'https://server1.pozi.com/Pozi/qgisserver?MAP=F:/Projects/Test/API/Council.qgs',
              show_legend: true
            }
          ]
        },
        {
          group_name: 'Planning Data',
          datasets: [
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92hc7',
              title: 'Planning Data',
              type: 1,
              url: 'https://server1.pozi.com/Pozi/qgisserver?MAP=F:/Projects/MNGdemo/Planning.qgs',
              show_legend: true
            }
          ]
        },
        {
          group_name: 'Imagery',
          datasets: [
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92ha8',
              title: 'ArcGIS World Imagery',
              type: 4,
              url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
              show_legend: true
            }
          ]
        },
        {
          group_name: 'Basemap',
          datasets: [
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92ha9',
              title: 'OpenStreetMap',
              type: 4,
              url: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png',
              show_legend: true
            },
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92kb9',
              title: 'HERE Map',
              type: 4,
              url: 'https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?style=explore.day&apiKey=uvyumsPYCINCZ_GY4GJqXeDbsj4DykbAic1qJNA4eHs',
              show_legend: true
            }
          ]
        }
      ]
    }
  },
  frankston: {
    public: {
      mapdatasets: [
        {
          group_name: 'Core',
          datasets: [
            {
              id: '343e586e-2c28-436c-8741-b94ff2c92jw7',
              title: 'Playgrounds',
              type: 2,
              url: 'https://opendata.maps.vic.gov.au/geoserver/ows?SERVICE=WFS&VERSION=1.1.0&srsName=EPSG:4326&typeNames=foi_point&cql_filter=feature_subtype=%27playground%27&outputFormat=application%2Fjson',
              show_legend: true
            },
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92ja7',
              title: 'Community',
              type: 1,
              url: 'https://server1.pozi.com/Pozi/qgisserver?MAP=F:/Projects/Test/API/Frankston.qgs&REQUEST=GetProjectSettings',
              show_legend: false
            },
            {
              id: '343e586e-2c28-436c-8741-b24ff2c92jw7',
              title: 'Main Roads',
              type: 2,
              url: 'https://opendata.maps.vic.gov.au/geoserver/ows?SERVICE=WFS&VERSION=1.1.0&srsName=EPSG:4326&typeNames=vmlite_tr_road&cql_filter=class_code=1&outputFormat=application%2Fjson',
              show_legend: true
            },
            {
              group_name: 'Administrative',
              datasets: [
                {
                  id: '343e586e-2c28-436c-8741-b94ff2c92ja7',
                  title: 'CFA Regions',
                  type: 2,
                  url: 'https://opendata.maps.vic.gov.au/geoserver/ows?SERVICE=WFS&VERSION=1.1.0&srsName=EPSG:4326&typeNames=cfa_region&outputFormat=application%2Fjson',
                  show_legend: true
                },
                {
                  id: '343e586e-2c28-436c-8741-b98ff2c92j2a',
                  title: 'Wards 2024',
                  type: 3,
                  url: 'https://opendata.maps.vic.gov.au/geoserver/ows?SERVICE=WMS&layers=ward_2024&layer=ward_2024',
                  show_legend: true
                },
                {
                  group_name: 'Administrative Level 2',
                  datasets: [
                    {
                      id: '343e586e-2c28-436c-8941-b94ff2c92ja7',
                      title: 'CFA Regions Level 2',
                      type: 2,
                      url: 'https://opendata.maps.vic.gov.au/geoserver/ows?SERVICE=WFS&VERSION=1.1.0&srsName=EPSG:4326&typeNames=cfa_region&outputFormat=application%2Fjson',
                      show_legend: true
                    },
                    {
                      id: '343e586e-2c28-436c-8941-b98ff2c92j2a',
                      title: 'Wards 2024 Level 2',
                      type: 3,
                      url: 'https://opendata.maps.vic.gov.au/geoserver/ows?SERVICE=WMS&layers=ward_2024&layer=ward_2024',
                      show_legend: false
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          group_name: 'Imagery',
          datasets: [
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92ja8',
              title: 'Google Imagery',
              type: 4,
              url: 'https://khms3.google.com/kh/v=1000?x={x}&y={y}&z={z}',
              show_legend: true
            },
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92jb8',
              title: 'Vicmap Aerial',
              type: 3,
              url: 'https://base.maps.vic.gov.au/service?Service=WMS&layers=AERIAL_WM_256',
              show_legend: true
            }
          ]
        },
        {
          group_name: 'Basemap',
          datasets: [
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92jb8',
              title: 'Vicmap Basemap',
              type: 3,
              url: 'https://base.maps.vic.gov.au/service?Service=WMS&layers=CARTO_WM_256',
              show_legend: true
            },
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92ja9',
              title: 'OpenStreetMap',
              type: 4,
              url: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png',
              show_legend: true
            },
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92kb9',
              title: 'HERE Map',
              type: 4,
              url: 'https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?style=explore.day&apiKey=uvyumsPYCINCZ_GY4GJqXeDbsj4DykbAic1qJNA4eHs',
              show_legend: true
            }
          ]
        }
      ]
    }
  },
  junee: {
    public: {
      mapdatasets: [
        {
          group_name: 'Core',
          datasets: [
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92ka7',
              title: 'Core Profile',
              type: 1,
              url: 'https://server1.pozi.com/Pozi/qgisserver?MAP=F:/Projects/Test/API/Junee.qgs',
              show_legend: true
            }
          ]
        },
        {
          group_name: 'Imagery',
          datasets: [
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92ka8',
              title: 'Google Imagery',
              type: 4,
              url: 'https://khms3.google.com/kh/v=1000?x={x}&y={y}&z={z}',
              show_legend: true
            }
          ]
        },
        {
          group_name: 'Basemap',
          datasets: [
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92ka9',
              title: 'OpenStreetMap',
              type: 4,
              url: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png',
              show_legend: true
            },
            {
              id: '343e586e-2c28-436c-8741-b98ff2c92kb9',
              title: 'HERE Map',
              type: 4,
              url: 'https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?style=explore.day&apiKey=uvyumsPYCINCZ_GY4GJqXeDbsj4DykbAic1qJNA4eHs',
              show_legend: true
            }
          ]
        }
      ]
    }
  }
}
